import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getResponseInfo = (state: AppState) => state.transfer.responseInfo;
const getTransferInfoPending = (state: AppState) => state.transfer.pendingInfo;
const getTransferError = (state: AppState) => state.transfer.error;

export const getTransferInfoSelector = createSelector(getResponseInfo, (info) => info);
export const getTransferInfoPendingSelector = createSelector(getTransferInfoPending, (status) => status);
export const getTransferErrorSelector = createSelector(getTransferError, (error) => error);
